import { render, staticRenderFns } from "./index7.vue?vue&type=template&id=00235dd6"
import script from "./index7.vue?vue&type=script&lang=js"
export * from "./index7.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports